import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  videoComplete?: boolean;
  purlLoginComplete?: boolean;
  purlInviteSent?: boolean;
  presentationComplete?: boolean;
  benefitCalculatorComplete?: boolean;
  cpaCallComplete?: boolean;
  scheduleACallCompleted?: boolean;
  softCommitComplete?: boolean;
  entityInformationCollected?: boolean;
  profileVerificationCompleted?: boolean;
  incomeLocationCompleted?: boolean;
  purlNdaChecked?: string | null;
  zohoCustomerId?: string;
  formData?: Object;
  billOfSaleSignedDate?: Date | null;
  zohoTrancheId?: string | null;
  lastProgressPercentage?: number;
}

type Props = {
  data?: {
    data?: {
      data?: FormResponse;
      message: string;
      success: boolean;
    };
  };
};

const initialState: UserState = {
  videoComplete: false,
  purlLoginComplete: false,
  purlInviteSent: false,
  presentationComplete: false,
  benefitCalculatorComplete: false,
  cpaCallComplete: false,
  scheduleACallCompleted: false,
  softCommitComplete: false,
  entityInformationCollected: false,
  profileVerificationCompleted: false,
  incomeLocationCompleted: false,
  purlNdaChecked: null,
  zohoCustomerId: "",
  formData: {},
  billOfSaleSignedDate: null,
  zohoTrancheId: null,
  lastProgressPercentage: 0,
};

export const stageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {
    setStage: (state, action: PayloadAction<UserState>) => {
      const {
        videoComplete = false,
        purlLoginComplete = false,
        purlInviteSent = false,
        presentationComplete = false,
        benefitCalculatorComplete = false,
        cpaCallComplete = false,
        scheduleACallCompleted = false,
        softCommitComplete = false,
        entityInformationCollected = false,
        profileVerificationCompleted = false,
        incomeLocationCompleted = false,
        purlNdaChecked = null,
        zohoTrancheId = null,
        billOfSaleSignedDate = null,
        lastProgressPercentage = 0,
      } = action.payload || {};

      Object.assign(state, {
        videoComplete,
        purlLoginComplete,
        purlInviteSent,
        presentationComplete,
        benefitCalculatorComplete,
        cpaCallComplete,
        scheduleACallCompleted,
        softCommitComplete,
        entityInformationCollected,
        profileVerificationCompleted,
        incomeLocationCompleted,
        purlNdaChecked,
        zohoTrancheId,
        billOfSaleSignedDate,
        lastProgressPercentage,
      });

      return state;
    },
    updateStage: (state, action: PayloadAction<Partial<UserState>>) => {
      return { ...state, ...action.payload };
    },
    updateFormData: (state, action: PayloadAction<any>) => {
      state.formData = action.payload;
      return state;
    },
  },
});

export const { setStage, updateStage, updateFormData } = stageSlice.actions;
export const selectFormData = (state: any) => state.stage?.formData;

export default stageSlice.reducer;
